export function formatSwissTel(str) {

    if (typeof str !== 'string') {
        return str;
    }

    const original = str.trim();

    // Remove spaces, dots, dashes, parentheses… keep digits and leading +
    let v = original.replace(/(?!^\+)[^\d]/g, '');

    let displayPrefix = '+41'; // default

    // 0041 -> +41
    if (v.startsWith('0041')) {
        v = '+41' + v.slice(4);
    }

    // National format: 0XXXXXXXXX
    if (!v.startsWith('+') && v.startsWith('0')) {
        const national = v.slice(1);
        if (/^\d{9}$/.test(national) && national[0] !== '0') {
            v = '+41' + national;
            displayPrefix = '0'; // remember national display
        }
    }

    // Accept only normalized +41 + 9 digits
    if (!v.startsWith('+41')) {
        return str;
    }

    const n = v.slice(3);
    if (!/^\d{9}$/.test(n)) {
        return str;
    }

    // Build display according to original intent
    if (displayPrefix === '0') {
        // 0xx xxx xx xx
        return `0${n.slice(0,2)} ${n.slice(2,5)} ${n.slice(5,7)} ${n.slice(7,9)}`;
    }

    // +41 xx xxx xx xx
    return `+41 ${n.slice(0,2)} ${n.slice(2,5)} ${n.slice(5,7)} ${n.slice(7,9)}`;
}
